export class Branch {
  documentType?: string;
  document?: number;
  queryCode?: number;
  branch?: string;
  establishment?: string;
  label?: string;

  public static fromResponse(json: any): Branch {
    return {
      documentType: json['tipoDocumento'],
      document: json['documento'],
      queryCode: json['codigoConsulta'],
      branch: json['sucursal'],
      establishment: json['establecimiento'],
      label: json['label'],
    };
  }
}
